import { useEffect } from 'react';
import {
  usePerformanceActions,
  useCurrentWorkspaceId,
  useCustomerHasAccessToPerformance,
} from 'src/store';

export const useMaintainPerformanceStoreState = () => {
  const customerHasAccessToPerformance = useCustomerHasAccessToPerformance();
  const currentWorkspaceId = useCurrentWorkspaceId();
  const performanceActions = usePerformanceActions();

  useEffect(() => {
    if (!currentWorkspaceId) {
      return;
    }

    performanceActions.restoreWorkspaceDataFromCache(currentWorkspaceId);

    performanceActions.queryChannelsAuthState().then(() => {
      performanceActions.queryConnectedAccounts(currentWorkspaceId);
    });

    return () => {
      performanceActions.cancelWaitRequests();
      performanceActions.clearStore(currentWorkspaceId);
    };
  }, [currentWorkspaceId, customerHasAccessToPerformance, performanceActions]);
};
